import { Link, NavLink } from "react-router-dom";

const socials = [
  {
    image: "https://cdn.kar-tini.id/ig_00e91cce8f.png",
    link: "https://www.instagram.com/kartiniotomasi/",
  },
  {
    image: "https://cdn.kar-tini.id/tik_efc621c4eb.png",
    link: "https://www.tiktok.com/@kartiniotomasi",
  },
  {
    image: "https://cdn.kar-tini.id/fb_136636d8d1.png",
    link: "https://www.facebook.com/kartiniotomasi",
  },
  {
    image: "https://cdn.kar-tini.id/in_67b2460dbf.png",
    link: "https://www.linkedin.com/company/kartini",
  },
  {
    image: "https://cdn.kar-tini.id/yt_fbff8e9b7f.png",
    link: "https://www.youtube.com/@kartiniotomasiindonesia3707",
  },
];

const Footer = () => {
  return (
    <footer>
      <div className="wrap foot">
        <div>
          <div className="brand" style={{ marginBottom: "14px" }}>
            <img src="https://cdn.kar-tini.id/logo_96d3f51682.png" alt="Kartini Logo" />
          </div>
          <p style={{ fontSize: "14px", marginRight: "5px" }}>
            Kartini is a promotion technology platform that connects brands, retailers and shoppers
            through a unified ecosystem. By combining conversational engagement, Image Recognition
            verification and real-time analytics, Kartini enables companies to deploy scalable
            consumer and trade promotions across modern retail environments.
          </p>
          <div className="socials">
            {socials.map((s, i) => (
              <a key={i} href={s.link} target="_blank" rel="noopener noreferrer" className="social">
                <img src={s.image} alt="social" />
              </a>
            ))}
          </div>
          <div className="copyright">Copyright Kartini International @2021-2026</div>
        </div>
        <div>
          <h4>Platform</h4>
          <div className="footlinks">
            <NavLink to="/consumer-promo" className={({ isActive }) => (isActive ? "active" : "")}>
              Consumer Promotions
            </NavLink>
            <NavLink to="/trade-promo" className={({ isActive }) => (isActive ? "active" : "")}>
              Trade Promotions
            </NavLink>
            <NavLink
              to="/display-receipt-ir"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              Display IR & Receipt IR
            </NavLink>
          </div>
        </div>
        <div>
          <h4>Company</h4>
          <div className="footlinks">
            <Link to="/" state={{ scrollTo: "founders" }}>
              Leadership
            </Link>
            <Link to="/" state={{ scrollTo: "customers" }}>
              Customers
            </Link>
            <Link to="/" state={{ scrollTo: "technology" }}>
              Technology
            </Link>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/" state={{ scrollTo: "technology" }}>
              CyberSecurity
            </Link>
          </div>
        </div>
        <div>
          <h4>Next</h4>
          <div className="footlinks">
            <Link to="/" state={{ scrollTo: "technology" }}>
              Analytics
            </Link>
            <Link to="/" state={{ scrollTo: "technology" }}>
              Retail Execution
            </Link>
            <Link to="/" state={{ scrollTo: "customers" }}>
              Testimonials
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
